module.exports = __webpack_public_path__ + "img/characterAnime6.033623d6.png";